import { employeeInputValue } from '../employeeInputValidation';
export default function BasicInformationStep({ formData, setFormData }) {
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: employeeInputValue(name, value, prev[name]),
    }));
  };

  return (
    <div className="space-y-8">
      {/* Profile Photo */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-3">
          Profile Photo
        </label>

        <div className="flex items-center gap-6">
          <div
            className="
              h-24
              w-24
              rounded-2xl
              bg-red-100
              text-red-800
              flex
              items-center
              justify-center
              text-2xl
              font-bold
            "
          >
            {formData.fullName
              ? formData.fullName
                  .split(" ")
                  .map((word) => word[0])
                  .join("")
                  .slice(0, 2)
              : "PH"}
          </div>

          <div>
            <input
              type="file"
              className="
                block
                text-sm
                text-gray-500
                file:mr-4
                file:py-2
                file:px-4
                file:rounded-xl
                file:border-0
                file:bg-red-50
                file:text-red-800
                file:font-medium
                hover:file:bg-red-100
              "
            />

            <p className="text-xs text-gray-400 mt-2">PNG, JPG up to 2MB</p>
          </div>
        </div>
      </div>

      {/* Personal Information */}
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-6">
          Personal Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Full Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Full Name
            </label>

            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Enter full name"
              className="
                w-full
                px-4
                py-3
                rounded-xl
                border
                border-gray-200
                focus:outline-none
                focus:ring-2
                focus:ring-red-800
              "
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700">
              Nickname / Preferred name
            </label>

            <input
              type="text"
              value={formData.nickname || ""}
              onChange={(event) =>
                setFormData((previous) => ({
                  ...previous,
                  nickname: event.target.value,
                }))
              }
              placeholder="For example: Simar, Sunny"
              maxLength={100}
              className="w-full rounded-xl border border-gray-200 px-4 py-3 outline-none transition focus:border-primary-800 focus:ring-2 focus:ring-primary-100"
            />

            <p className="mt-1.5 text-xs text-gray-500">
              Optional. Official payroll and documents continue to use full
              name.
            </p>
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Leave blank for fullname@charmscollections.in"
              className="
                w-full
                px-4
                py-3
                rounded-xl
                border
                border-gray-200
                focus:outline-none
                focus:ring-2
                focus:ring-red-800
              "
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Phone Number
            </label>

            <input
              type="tel"
              name="phone"
              aria-label="Mobile number"
              inputMode="numeric"
              maxLength={10}
              pattern="[0-9]{10}"
              title="Exactly 10 digits"
              value={formData.phone}
              onChange={handleChange}
              placeholder="9876543210"
              className="
                w-full
                px-4
                py-3
                rounded-xl
                border
                border-gray-200
                focus:outline-none
                focus:ring-2
                focus:ring-red-800
              "
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Initial Login Password
            </label>

            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Leave blank for the standard employee password"
              className="
      w-full
      px-4
      py-3
      rounded-xl
      border
      border-gray-200
      focus:outline-none
      focus:ring-2
      focus:ring-red-800
    "
            />

            <p className="mt-2 text-xs text-gray-400">
              Leave both email and password blank to create the default
              <span className="font-medium text-gray-600"> fullname@charmscollections.in </span>
              login with password <span className="font-medium text-gray-600">Charms@2462</span>.
            </p>
          </div>

          {/* Gender */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Gender
            </label>

            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="
                w-full
                px-4
                py-3
                rounded-xl
                border
                border-gray-200
                bg-white
                focus:outline-none
                focus:ring-2
                focus:ring-red-800
              "
            >
              <option value="">Select Gender</option>

              <option value="Male">Male</option>

              <option value="Female">Female</option>

              <option value="Other">Other</option>
            </select>
          </div>

          {/* DOB */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Date of Birth
            </label>

            <input
              type="date"
              name="dob"
              aria-label="Date of birth"
              min="0001-01-01"
              max="9999-12-31"
              value={formData.dob}
              onChange={handleChange}
              className="
                w-full
                px-4
                py-3
                rounded-xl
                border
                border-gray-200
                focus:outline-none
                focus:ring-2
                focus:ring-red-800
              "
            />
          </div>
        </div>
      </div>
    </div>
  );
}
